import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { INotification } from '@ebb-v2/ebb-integration';


@Component({
    selector: 'app-notification',
    templateUrl: './notification.component.html',
    standalone: false
})
export class NotificationComponent {
    @Input() notification: INotification;
    @Output() closeNotification = new EventEmitter<string>();
  safeHtmlContent: SafeHtml;
  safeHtmlName  : SafeHtml;
  constructor(private sanitizer: DomSanitizer) {}

  ngOnInit(): void {

    const updatedContent = this.notification.content.replace(/\/portal/g, this.geturl());
    this.safeHtmlContent = this.sanitizeAnswer(updatedContent);
  }
  close(): void {
    this.notification.hide = true;
    this.closeNotification.emit(this.notification.id);
  }
sanitizeAnswer(answer: string): SafeHtml {
  return this.sanitizer.bypassSecurityTrustHtml(answer);
}

  geturl(): string {
    const url = new URL(window.location.href);
    url.search = ""; // Remove query parameters
    if (url.pathname.endsWith("/home")) {
        url.pathname = url.pathname.replace("/home", "");
    }
    return url.toString();
}
}
